import type { FaireProductEntity } from "../../entity_types/product";

export const p_ycg4xx76n7: FaireProductEntity = {
  token: "p_ycg4xx76n7",
  type: "product",
  name: "Cinnamon Roll Rooibos - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/2be2fb029f7a15570a8736354d27b5e1c80915aee100d3b9c38edbe290bdd1b4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21d1f8588bea6a1405355da4b0a6c892613942039fe2d320ec667be2ce7f19c1.png"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nThis comforting tea captures the sweetness of cozy cinnamon rolls fresh from the oven - without the sticky hands or sugar crash! Organic cinnamon and rooibos, stress-soothing tulsi and superfood chicory root come together for a dessert-like tea that you can feel good about. Swirl in your favourite honey and top with frothed milk for an extra treat - you deserve it!\n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \nWhen to Steep:\n\n\n * As an afternoon treat without the sugar. \n * When you are under stress. \n * When you are feeling under the weather. \n * As a warming and digestion-supporting after-dinner treat. \n * To help wind-down before bed. \nCaffeine-free\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:41.059Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
